<template>
  <el-container class="chart-edit">
    <el-header style="height:52px">
      <chart-edit-header :chart="chart" :board="board" @save="saveChart"></chart-edit-header>
    </el-header>
    <el-main class="edit-main">
      <el-container style="height:100%">
        <el-aside width="254px" class="edit-aside">
          <div class="aside-header">
            <div class="header-title">
              <div>数据源</div>
              <el-button
                v-show="chart.sheetId"
                @click="toEdit"
                type="text"
                class="el-icon-edit-outline header-button"
              ></el-button>
            </div>
            <tree-select
              :group-list="sheetGroupList"
              :value="chart.sheetId"
              @input="selectDef"
            ></tree-select>
          </div>
          <div class="aside-main">
            <div class="main-title">
              <div class="main-text">字段</div>
              <el-button
                type="text"
                class="el-icon-refresh main-button"
                @click="refreshFields"
                :class="active ? 'button-active' : ''"
              ></el-button>
            </div>
            <el-input
              class="main-input"
              v-model="searchText"
              size="small"
              placeholder="搜索字段"
              clearable
              prefix-icon="el-icon-search"
              @input="searchControls"
            ></el-input>
            <div class="data-kind">
              <div class="dimension">
                <span class="title">维度</span>
                <el-menu class="aside-menu" v-ps>
                  <draggable
                    :group="{ name: 'x-control', pull: 'clone', put: false }"
                    :sort="false"
                    :list="filterSheetControls"
                    :clone="cloneControl"
                    handle=".drag-item"
                    @start="onStartX"
                    @end="onEnd"
                  >
                    <el-menu-item
                      class="drag-item"
                      v-for="(item, index) in filterSheetControls"
                      :key="index"
                      :index="item._cid"
                    >
                      <svg-icon :icon-class="'control_' + item._type" class="item-icon"></svg-icon>
                      <span v-tip>{{ item.name }}</span>
                    </el-menu-item>
                  </draggable>
                </el-menu>
              </div>
              <div class="quota">
                <div class="title">
                  <span class="name">指标</span>
                  <el-button type="text" @click="addQuota">+添加</el-button>
                </div>
                <el-menu class="aside-menu" v-ps>
                  <draggable
                    :group="{ name: 'y-control', pull: 'clone', put: false }"
                    :sort="false"
                    :list="filterQuotas"
                    :clone="cloneQuotaControl"
                    handle=".drag-item"
                    @start="onStartY"
                    @end="onEnd"
                  >
                    <el-menu-item
                      class="drag-item"
                      v-for="(item, index) in filterQuotas"
                      :key="index"
                      :index="item.id"
                    >
                      <svg-icon
                        icon-class="chart_quota"
                        class="item-icon"
                        style="margin-right: 5px"
                      ></svg-icon>
                      <span v-tip>{{ item.name }}</span>
                      <i
                        class="el-icon-edit-outline quota-operation"
                        style="font-size: 15px"
                        @click="editQuota(item)"
                      ></i>
                      <i
                        class="el-icon-delete quota-operation"
                        style="font-size: 15px"
                        @click="delQuota(item.id)"
                      ></i>
                    </el-menu-item>
                  </draggable>
                </el-menu>
              </div>
            </div>
          </div>
        </el-aside>
        <el-container>
          <div style="width:100%" v-ps>
            <el-header style="height:auto">
              <setting-header
                ref="settingHeader"
                :chart="chart"
                :selectChart="selectChart"
                :canSetting="canSetting"
              ></setting-header>
              <el-button class="appliance-button" type="primary" @click="appliance">应用</el-button>
            </el-header>
            <el-main>
              <div class="main-chart" :class="'board-theme-' + board.theme">
                <div class="chart-title">
                  <span style="margin-right: 4px" v-if="chart.showName">{{ chart.name }}</span>
                  <el-tooltip
                    v-if="chart.desc"
                    class="item"
                    effect="dark"
                    :content="chart.desc"
                    placement="right-start"
                  >
                    <i class="el-icon-info pointer"></i>
                  </el-tooltip>
                </div>
                <div class="main-empty" v-if="!chart.isShow" z-index="2">
                  <svg-icon icon-class="chart_empty" class="icon-empty"></svg-icon>
                  <div style="color:#c0c4cc;font-size:14px">还未配置数据或字段</div>
                </div>
                <chart-item
                  ref="myChart"
                  :chart="chart"
                  :theme="board.theme"
                  :board-id="board.id"
                  :app-id="board.appId"
                  class="image"
                  z-index="1"
                ></chart-item>
              </div>
            </el-main>
          </div>
        </el-container>
        <el-aside style="text-align: left">
          <side-menu :chart="chart"></side-menu>
        </el-aside>
      </el-container>
    </el-main>
    <quota-dialog
      ref="quota"
      :operation="operation"
      :quota="quota"
      :sheet="sheet"
      :sheet-controls="sheetControls"
      @change="getQuotas"
    ></quota-dialog>
  </el-container>
</template>
<script>
import ChartEditHeader from "./chartEditHeader"
import draggable from "vuedraggable"
import { getAvailableSheets, getObjectId, getSheet } from "@/api/sheet/sheet"
import { decorateSheet, transFieldControl, verifyCondition } from "@/utils/sheet"
import { deepClone, stringIncludes } from "@/utils/common"
import { updateCharts } from "@/api/appManage/statistics"
import { getExtraFields, deleteExtraField } from "@/api/bi"
import SettingHeader from "./SettingHeader.vue"
import ChartItem from "./ChartItem.vue"
import SideMenu from "@/views/Backend/Admin/Statistics/chartEdit/SideMenu"
import QuotaDialog from "@/views/Backend/Admin/Statistics/chartEdit/QuotaDialog"
import TreeSelect from "@/components/UIComponents/TreeSelect.vue"

export default {
  name: "chart-edit",
  components: {
    QuotaDialog,
    SideMenu,
    ChartEditHeader,
    draggable,
    SettingHeader,
    ChartItem,
    TreeSelect
  },
  provide() {
    return { sheetControls: this.sheetControls }
  },
  data() {
    return {
      searchText: "",
      sheetMap: {},
      sheetGroupList: [],
      filterSheetControls: [],
      quotas: [],
      filterQuotas: [],
      sheetControls: [],
      chart: {},
      selectChart: "",
      filledPreCondition: [],
      board: {},
      canSetting: {
        x: "null",
        y: "null"
      },
      active: false,
      operation: "addQuota",
      quota: {
        name: "",
        desc: "",
        cid: "",
        groupType: "",
        groupFilters: []
      },
      sheet: {}
    }
  },
  created() {
    this.refresh()
  },
  computed: {
    sheetControlsMap() {
      let result = {}
      this.sheetControls.forEach(control => (result[control._cid] = control))
      return result
    },
    quotaControlsMap() {
      let result = {}
      this.quotas.forEach(quota => (result[quota.id] = quota))
      return result
    }
  },
  methods: {
    refresh() {
      this.board = JSON.parse(localStorage.getItem("board"))
      if (this._.isEmpty(this.board)) return this.$message.error("初始化失败")
      this.chart = deepClone(this.board.charts[this.board.index])
      this.$set(this.chart, "isShow", false)
      if (!this.chart.name) this.$set(this.chart, "name", "未命名")
      this.selectChart = this.chart.type
      getAvailableSheets({ appId: this.board.appId }).then(availableSheets => {
        this.initSheetGroup(availableSheets)
        if (this.chart.sheetId) this.selectDef(this.chart.sheetId, true)
        this.refreshChart()
      })
      if (this.chart.sheetId) this.getQuotaRelated(this.chart.sheetId)
      if (
        (this.chart.xAxisList && this.chart.xAxisList.length > 0) ||
        (this.chart.yAxisList && this.chart.yAxisList.length > 0)
      )
        setTimeout(() => {
          this.$refs.myChart.init(this.chart)
        }, 300)
    },
    getQuotaRelated(sheetId) {
      getSheet(sheetId).then(res => (this.sheet = decorateSheet(res)))
      this.getQuotas(sheetId)
    },
    getQuotas(sheetId) {
      getExtraFields(sheetId).then(res => {
        this.quotas = res.fieldList
        this.filterQuotas = this.quotas
      })
    },
    searchControls() {
      this.filterSheetControls = this.sheetControls.filter(i =>
        stringIncludes(i.name, this.searchText)
      )
      this.filterQuotas = this.quotas.filter(q => q.name.includes(this.searchText))
    },
    initSheetGroup(availableSheets) {
      this.sheetMap = Object.freeze(
        this._.keyBy(
          availableSheets.flatMap(app => app.sheets),
          "sheetId"
        )
      )
      this.sheetGroupList = Object.freeze(
        availableSheets.map(app => ({
          label: app.name,
          options: app.sheets.map(sheet => ({
            label: sheet.name,
            value: sheet.sheetId
          }))
        }))
      )
    },
    refreshFields() {
      this.active = true
      setTimeout(() => (this.active = false), 1000) // 转一秒
      getAvailableSheets({ appId: this.board.appId, cache: false }).then(availableSheets => {
        this.initSheetGroup(availableSheets)
        if (this.chart.sheetId) this.selectDef(this.chart.sheetId, true)
      })
    },
    selectDef(sheetId, isRefresh = false) {
      this.getQuotaRelated(sheetId)
      this.chart.sheetId = sheetId
      let sheet = this.sheetMap[sheetId]
      this.sheetControls.splice(
        0,
        this.sheetControls.length,
        ...(sheet.controls || [])
          .concat([
            {
              name: "ID",
              _cid: "id",
              _type: "ref",
              refSheetId: sheet.sheetId,
              oneFlag: true
            },
            { name: "创建人", _cid: "cid", _type: "staff" },
            { name: "负责人", _cid: "oid", _type: "staff" },
            { name: "最后修改人", _cid: "upid", _type: "staff" },
            { name: "创建时间", _cid: "cat", _type: "time" },
            { name: "最后修改时间", _cid: "uat", _type: "time" }
          ])
          .map(control => transFieldControl(control))
      )
      this.filterSheetControls =
        this.chart.type === "map"
          ? deepClone(this.sheetControls).filter(
              control => control._type === "area" && control.oneFlag
            )
          : deepClone(this.sheetControls).filter(
              control =>
                !(
                  control._dataType === "number" ||
                  (this._.keys(control).includes("oneFlag") &&
                    !["staff", "department", "company", "area", "option"].includes(
                      control._type
                    )) ||
                  ["remark", "select2", "location", "sign", "chart"].includes(control._type)
                )
            )
      if (!isRefresh) {
        this.chart.xAxisList = []
        this.chart.yAxisList = []
        this.chart.filters = []
        this.$refs.settingHeader.refresh()
      }
    },
    refreshChart() {
      if (!this.chart.xAxisList) this.$set(this.chart, "xAxisList", [])
      else {
        this.chart.xAxisList.map(x => {
          this.$set(x, "control", this.sheetControlsMap[x.cid])
        })
      }
      if (!this.chart.yAxisList) this.$set(this.chart, "yAxisList", [])
      else {
        this.chart.yAxisList.map(y => {
          this.$set(y, "field", this.quotaControlsMap[y.fieldId])
        })
      }
    },
    appliance() {
      let setting = this.$refs.settingHeader
      let { result, msg } = verifyCondition("submit", setting.filledPreCondition)
      if (!result) {
        this.$message.error(msg)
        return
      } else {
        let chart = this.chart
        chart.filters = setting.filledPreCondition
        this.$refs.myChart.init(chart)
      }
    },
    cloneControl(obj) {
      let control = this._.cloneDeep(obj)
      return this.setXControl(control)
    },
    setXControl(control) {
      let result = {}
      getObjectId().then(res => (result.id = res.slice(1)))
      result.control = control
      result.cid = control._cid
      result.name = control.name
      result.type = "ROW"
      result.sortDirection =
        control._type === "time" || this.chart.type === "cross-table" ? "ASC" : null
      return this.chart.type === "map" ? this.setDownList(result) : result
    },
    setDownList(item) {
      item.projectType = "省"
      let drillDownList = []
      let control = item.control
      switch (control.level) {
        case 2: {
          let drillDown = this.getDrillDown(item, "市")
          getObjectId().then(id => {
            drillDown.id = id.slice(1)
            drillDownList.push(drillDown)
          })
          break
        }
        case 3:
        case 4: {
          let drillDown = this.getDrillDown(item, "市")
          getObjectId().then(id => {
            drillDown.id = id.slice(1)
            drillDownList.push(drillDown)
          })
          let drillDown1 = this.getDrillDown(item, "区")
          getObjectId().then(id => {
            drillDown1.id = id.slice(1)
            drillDownList.push(drillDown1)
          })
          break
        }
      }
      this.$set(item, "drillDownList", drillDownList)
      return item
    },
    getDrillDown(item, projectType) {
      let drillDown = deepClone(item)
      drillDown.projectType = projectType
      return drillDown
    },
    cloneQuotaControl(obj) {
      let field = this._.cloneDeep(obj)
      return this.setYCField(field)
    },
    setYCField(field) {
      let result = {}
      getObjectId().then(res => (result.id = res.slice(1)))
      result.field = field
      result.fieldId = field.id
      result.name = field.name
      result.type = "NORMAL"
      result.hidden = false
      return result
    },
    saveChart() {
      let chart = this.chart
      let setting = this.$refs.settingHeader
      if (setting.filledPreCondition?.length > 0) chart.filters = setting.filledPreCondition
      this.board.charts[this.board.index] = deepClone(chart)
      if (!this.chart.name) {
        this.$message.error("统计图名称必填")
      } else {
        updateCharts(this.board).then(res => {
          localStorage.setItem("board", JSON.stringify(this.board))
          this.$message.success("保存成功")
        })
      }
    },
    toEdit() {
      const { href } = this.$router.resolve({
        name: "edit-sheet-field",
        query: { sheetId: this.chart.sheetId }
      })
      window.open(href, "_blank")
    },
    onStartX() {
      this.canSetting = {
        x: "true",
        y: "false"
      }
    },
    onStartY() {
      this.canSetting = {
        x: "false",
        y: "true"
      }
    },
    onEnd() {
      this.canSetting = {
        x: "null",
        y: "null"
      }
    },
    addQuota() {
      this.operation = "addQuota"
      this.quota = this.$options.data().quota
      this.$nextTick(() => {
        this.$refs.quota?.open()
      })
    },
    editQuota(item) {
      this.operation = "editQuota"
      this.quota = item
      this.$nextTick(() => {
        this.$refs.quota?.open()
      })
    },
    delQuota(id) {
      deleteExtraField(id, this.sheet.sheetId).then(() => {
        this.getQuotas(this.sheet.sheetId)
        this.$message.success("删除成功")
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-edit {
  height: 100%;
  .edit-main {
    padding: unset;
    background-color: #ffffff;
    .edit-aside {
      box-shadow: 0px 0px 4px 0px #c0c4cc;
      .aside-header {
        padding: 10px 20px;
        border-bottom: 1px solid rgba(225, 227, 234, 1);
        .header-title {
          font-weight: 500;
          font-size: 14px;
          display: flex;
          margin-bottom: 5px;
          .header-button {
            padding: unset;
            margin-left: auto;
            color: #bdbdbd;
            font-size: 18px;
          }
        }
        .header-select {
          margin-top: 8px;
          width: 214px;
        }
      }

      .aside-main {
        .main-title {
          display: flex;
          align-items: center;
          padding: 10px 20px 0 20px;
          .main-text {
            font-size: 14px;
            font-weight: 500;
          }
          .main-button {
            padding: unset;
            margin-left: auto;
            color: #bdbdbd;
            font-size: 18px;
          }
          .button-active {
            animation: rotate 1s infinite;
            -webkit-animation: rotate 1s infinite;
          }
          @keyframes rotate {
            0% {
              transform: rotate(0deg);
              -ms-transform: rotate(0deg); /* IE 9 */
              -moz-transform: rotate(0deg); /* Firefox */
              -o-transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
              -ms-transform: rotate(360deg); /* IE 9 */
              -moz-transform: rotate(360deg); /* Firefox */
              -o-transform: rotate(360deg);
            }
          }

          @-webkit-keyframes rotate {
            0% {
              -moz-transform: rotate(0deg);
            }
            100% {
              -moz-transform: rotate(360deg);
            }
          }
        }
        .main-input {
          margin-top: 8px;
          width: 214px;
        }
        .data-kind {
          height: calc(100vh - 228px);
          display: flex;
          flex-flow: column;
          text-align: left;
          border-right: none;
          .el-menu {
            border-right: unset;
          }
          .dimension {
            flex: 1;
            margin-left: 20px;
            display: flex;
            flex-flow: column;
            overflow: hidden;
            .title {
              font-size: 14px;
              font-weight: 500;
              margin-top: 10px;
            }
            .aside-menu {
              flex: 1;
            }
          }
          .quota {
            flex: 1;
            border-top: 2px solid #e4e7ed;
            display: flex;
            flex-flow: column;
            overflow: hidden;
            .title {
              display: flex;
              justify-content: space-between;
              margin: 10px 20px;
              .name {
                font-size: 14px;
                font-weight: 500;
              }
              .el-button {
                padding: 0;
                font-size: 13px;
              }
            }
            .aside-menu {
              margin-left: 20px;
              flex: 1;
            }
          }
        }
      }
    }
  }
}
.el-footer {
  background-color: #b3c0d1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  text-align: center;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  padding: 10px;
  .main-empty {
    top: 50%;
    position: relative;
    margin-top: -95px;
    .icon-empty {
      height: 72px;
      width: 72px;
    }
  }
  .main-chart {
    height: 57vh;
    background: white;

    .chart-title {
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 10px;
      top: 16px;
      font-size: 16px;
      height: 24px;
    }
  }
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.el-header {
  .el-form-item {
    margin-bottom: 0px;
    border-bottom: 1px solid rgba(220, 223, 230, 0.8);
  }
  .svg-list {
    align-items: center;
    display: flex;
    height: 60px;
    .svg-item {
      height: 40px;
      width: 40px;
      margin-right: 12px;
    }
  }
  .appliance-button {
    width: 64px;
    height: 32px;
    padding: unset;
    display: block;
    margin: 16px 0;
  }
}
.drag-item {
  padding-left: 1px !important;
  line-height: 40px;
  height: 40px;
  font-size: 13px;
  align-items: center;
  display: flex;
  .item-icon {
    height: 18px;
    width: 18px;
    margin-right: 3px;
    color: #1989fa;
  }
  .quota-operation {
    visibility: hidden;
  }
  &:hover {
    .quota-operation {
      visibility: visible;
    }
  }
}
::v-deep .el-submenu__icon-arrow {
  left: 0px;
  right: unset;
}
.setting-header {
  ::v-deep .el-radio-button:first-child .el-radio-button__inner {
    border-left: 2px solid #ffffff;
  }
  ::v-deep .el-radio-button__inner {
    border-radius: 4px !important;
    border: 2px solid #ffffff;
    padding: 0;
    box-shadow: none !important;
  }
  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: white;
    border-color: #409eff !important;
  }
  ::v-deep .el-radio-button__orig-radio:disabled + .el-radio-button__inner {
    border-color: #ffffff;
  }
}
.image {
  overflow: hidden;
  flex: 1;
  height: calc(100% - 48px);
  width: 100%;
  padding: 30px 10px 0 10px;
  box-sizing: border-box;
}
</style>
